import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { Provider } from './context';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Gallery from './components/Gallery';
import ScrollToTop from './components/ScrollToTop';
import NFTsection from './components/NFTsection';
import DigitalIllustrations from './components/Pages/DigitalIllustrations';
import Lettering from './components/Pages/Lettering';
import PopCulture from './components/Pages/PopCulture';
import Paintings from './components/Pages/Paintings';
import BlackInk from './components/Pages/BlackInk';
import Inktober2020 from './components/Pages/Inktober2020';
import Portraits from './components/Pages/Portraits';
import About from './components/About';
import Mandalas from './components/Pages/Mandalas';
import Blogs from './components/Pages/Blogs';

function App() {
  return (
    <Provider>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Switch>
          <Route exact path="/" component={HomePage}></Route>
          <Route exact path="/about" component={About}></Route>
          <Route exact path="/blogs" component={Blogs}></Route>
          <Route exact path="/gallery" component={Gallery}></Route>
          <Route exact path="/gallery/illustrations" component={DigitalIllustrations}></Route>
          <Route exact path="/gallery/mandalas" component={Mandalas}></Route>
          <Route exact path="/gallery/portraits" component={Portraits}></Route>
          <Route exact path="/gallery/lettering" component={Lettering}></Route>
          <Route exact path="/gallery/popCulture" component={PopCulture}></Route>
          <Route exact path="/gallery/inktober2020" component={Inktober2020}></Route>
          <Route exact path="/gallery/blackInk" component={BlackInk}></Route>
          <Route exact path="/gallery/paintings" component={Paintings}></Route>
        </Switch>
        <NFTsection />
        <Footer />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
